<template>
    <div class="contanierBox">
        <div class="header">
            <div class="routeTit">
                <img src="../../assets/img/back.png" class="backIcon" @click='toBack()'>
            </div>
            <div class="title">{{$route.meta.title}}</div>
            <div class="tools" @click="goHome()">
                <img src="../../assets/img/home.png">
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: '',
    data () {
        return {
            menuIndex: 1,
            curPath: '',
            newTitle: ''
        }
    },
    
    methods: {
        /**
         ** 返回首页
         */
        goHome () {
            this.$router.push('/')
        },
        /**
         ** 返回一层
         */
        toBack () {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="scss" scoped>
    .header {
        width: 100%;
        height: 100px;
        background: $base-color;
        padding: 0 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        text-align: center;
        top: 0;
        left: 0;
        z-index: 999;
        .routeTit{
            height: 34px;
            font-size: 36px;
            font-weight: 500;
            letter-spacing: 2px;
            color: #ffffff;
            line-height: 34px;
            display: flex;
            flex-direction: row;
            .backIcon {
                width: 40px;
                height: 40px;
                margin-right: 26px;
            }
        }
        .title {
            font-size: 36px;
            // font-weight: 700;
            text-align: center;
            color: #fffefe;
        }
        .tools {
            img {
                    width: 40px;
                    height: 40px;
                    display: block;
                }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue